// FontAwesome 6 Pro integration
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Solid – alle Icons laden (für DB-gesteuerte Icons wie Benefits)
import { fas } from '@fortawesome/pro-solid-svg-icons'
library.add(fas);

// import {
//     faXmark as faXmarkSharp,
// } from '@fortawesome/'
// library.add(
//     faXmarkSharp,
// );

// Regular – alle Icons laden (für DB-gesteuerte Icons wie Benefits)
import { far } from '@fortawesome/pro-regular-svg-icons';
library.add(far);

// Brands
import {
    faFacebookF,
    faFacebook,
    faInstagram,
    faTiktok,
    faYoutube,
    faXTwitter,
    faLinkedin,
    faLinkedinIn,
    faGoogle,
} from '@fortawesome/free-brands-svg-icons';
library.add(
    faFacebookF,
    faFacebook,
    faInstagram,
    faTiktok,
    faYoutube,
    faXTwitter,
    faLinkedin,
    faLinkedinIn,
    faGoogle,
);

// Duotone
import {
    faMessage as faMessageDuotone,
    faFileLines as faFileLinesDuotone,
    faFileCircleInfo as faFileCircleInfoDuotone,
    faBusinessTime as faBusinessTimeDuotone,
    faPeopleGroup as faPeopleGroupDuotone,
    faMessagesQuestion as faMessagesQuestionDuotone,
    faMicrochipAi as faMicrochipAiDuotone,
    faBullhorn as faBullhornDuotone,
} from '@fortawesome/pro-duotone-svg-icons';
library.add(
    faMessageDuotone,
    faFileLinesDuotone,
    faFileCircleInfoDuotone,
    faBusinessTimeDuotone,
    faPeopleGroupDuotone,
    faMessagesQuestionDuotone,
    faMicrochipAiDuotone,
    faBullhornDuotone,
);

// Thin
import {
    faCaretDown as faCaretDownLight,
    faCaretUp as faCaretUpLight,
} from '@fortawesome/pro-thin-svg-icons';
library.add(
    faCaretDownLight,
    faCaretUpLight,
);


// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch()
